export default "__VITE_ASSET__e9424d74__"